import { Box } from '@chakra-ui/react';

import { AndroidMock } from '$components/ui/device-mock/android';
import { SafariMock } from '$components/ui/device-mock/safari';

interface ProjectImageProps {
  image?: string | null;
  alt: string;
  category: string;
  url?: string | null;
}

export function ProjectImage({ image, alt, category, url }: ProjectImageProps) {
  if (!image) return null;

  const isMobile = category === 'mobile';

  if (isMobile) {
    return (
      <Box
        mx="auto"
        w="full"
        maxW={{ base: '280px', md: '340px' }}
        h={{ base: '520px', md: '640px' }}
      >
        <AndroidMock src={image} alt={alt} />
      </Box>
    );
  }

  return (
    <Box w="full" h={{ base: '280px', md: '480px' }}>
      <SafariMock src={image} alt={alt} url={url ?? undefined} />
    </Box>
  );
}
